import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJamboardComponent } from './simple-icons-jamboard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJamboardComponent ],
    exports:      [ SimpleIconsJamboardComponent ],
    bootstrap:    []
})
export class SimpleIconsJamboardModule {}
